import { base, baseSepolia } from "viem/chains";

const baseNetworkConfig = {
  network: base,
  chainExplorer: {
    basePath: "https://basescan.org",
  },
  walletCapabilities: {
    paymasterUrl: "https://api.developer.coinbase.com/rpc/v1/base/Cd4G2wfMFyiyx2CKJHbyao0fWPqOCyh4",
  },
  raribleSDK: {
    environment: "prod",
    apiKey: "8d6c289e-0314-4cd2-acff-67f89b35a191",
    exchange: "0x6C65a3C3AA67b126e43F86DA85775E0F5e9743F7",
    erc721Factory: "0xf965237c6b3f89f8c62b45b94097899e3562a830",
    erc1155Factory: "0xd37dc0cd86dfa9b2b57cd7dfa8b6aa0092a9517d",
  },
  currencies: {
    usdc: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
  },
};

const baseSepoliaNetworkConfig = {
  network: baseSepolia,
  chainExplorer: {
    basePath: "https://sepolia.basescan.org",
  },
  walletCapabilities: {
    paymasterUrl: "https://api.developer.coinbase.com/rpc/v1/base-sepolia/Cd4G2wfMFyiyx2CKJHbyao0fWPqOCyh4",
  },
  raribleSDK: {
    environment: "testnet",
    apiKey: "717b8186-8d5c-44a6-83fb-b842b6c87917",
    exchange: "0x0fE65B68Eb627c21EAF3cfe8183C4F946F3d48BD",
    erc721Factory: "0xB020bA7fcF43DCc59eF0103624BD6FADE66d105E",
    erc1155Factory: "0x166f6180170f438ddc38050a2b708d38c0890956",
  },
  currencies: {
    usdc: "0x036cbd53842c5426634e7929541ec2318f3dcf7e",
  },
};

const networkConfigs = new Map([
  [base.id, baseNetworkConfig],
  [baseSepolia.id, baseSepoliaNetworkConfig],
]);

export const configForChainId = (chainId) => {
  const result = networkConfigs.get(chainId);
  if (!result) {
    throw new Error(`Requested config for unsupported chainId: ${chainId}`);
  }
  return result;
};